import { SceneObject, Behavior } from '../types';

// A styled item preset = a single primitive with a preset look and a
// behavior already attached. No engine change required — it's just
// addObject(type) followed by applying these overrides.
export interface ItemPreset {
  id: string;
  label: string;
  type: SceneObject['type'];
  color: string;
  baseName: string;
  scale: { x: number; y: number; z: number };
  rotation?: { x: number; y: number; z: number };
  behaviors: Behavior[];
}

const s = (x: number, y: number, z: number) => ({ x, y, z });

export const ITEM_PRESETS: ItemPreset[] = [
  {
    id: 'player',
    label: 'Player',
    type: 'cube',
    color: '#2B8CFF',
    baseName: 'Player',
    scale: s(1, 1, 1),
    behaviors: [{ type: 'player', params: { speed: 6 } }],
  },
  {
    id: 'coin',
    label: 'Coin',
    type: 'sphere',
    color: '#F4B942',
    baseName: 'Coin',
    scale: s(0.5, 0.5, 0.5),
    behaviors: [{ type: 'collectible', params: { points: 1 } }],
  },
  {
    id: 'gem',
    label: 'Gem',
    type: 'sphere',
    color: '#A855F7',
    baseName: 'Gem',
    scale: s(0.6, 0.6, 0.6),
    behaviors: [{ type: 'collectible', params: { points: 5 } }],
  },
  {
    id: 'crate',
    label: 'Crate',
    type: 'cube',
    color: '#8A6D3B',
    baseName: 'Crate',
    scale: s(1, 1, 1),
    behaviors: [{ type: 'obstacle', params: {} }],
  },
  {
    id: 'wall',
    label: 'Wall',
    type: 'cube',
    color: '#5B6470',
    baseName: 'Wall',
    scale: s(1, 1, 4),
    behaviors: [{ type: 'obstacle', params: {} }],
  },
  {
    id: 'hazard',
    label: 'Hazard',
    type: 'cube',
    color: '#EF4444',
    baseName: 'Hazard',
    scale: s(1, 1, 1),
    behaviors: [{ type: 'hazard', params: {} }],
  },
  {
    id: 'goal',
    label: 'Goal',
    type: 'cube',
    color: '#22C55E',
    baseName: 'Goal',
    scale: s(1, 1, 1),
    behaviors: [{ type: 'goal', params: { requireAllCollectibles: true } }],
  },
  {
    id: 'floor',
    label: 'Floor',
    type: 'plane',
    color: '#15151F',
    baseName: 'Ground',
    scale: s(16, 16, 1),
    rotation: { x: -Math.PI / 2, y: 0, z: 0 },
    behaviors: [],
  },
  {
    id: 'bush',
    label: 'Bush',
    type: 'sphere',
    color: '#4FB36A',
    baseName: 'Bush',
    scale: s(0.8, 0.7, 0.8),
    behaviors: [],
  },
  {
    id: 'rock',
    label: 'Rock',
    type: 'sphere',
    color: '#737B89',
    baseName: 'Rock',
    scale: s(0.9, 0.6, 0.9),
    behaviors: [{ type: 'obstacle', params: {} }],
  },
  {
    id: 'pillar',
    label: 'Pillar',
    type: 'cube',
    color: '#5B6470',
    baseName: 'Pillar',
    scale: s(0.8, 3, 0.8),
    behaviors: [{ type: 'obstacle', params: {} }],
  },
];
